import React from 'react';
import { Modal, Table, Badge, Button } from 'react-bootstrap';

/**
 * Master Data Preview Modal
 * Displays a preview of master data options for a form field
 */
const MasterDataPreviewModal = ({
  show,
  onHide,
  fieldLabel,
  options = [],
  tableName,
  columnName
}) => {
  return (
    <Modal show={show} onHide={onHide} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>
          Preview Options for "{fieldLabel}"
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="mb-3">
          {tableName && <Badge bg="info" className="me-2">Table: {tableName}</Badge>}
          {columnName && <Badge bg="info" className="me-2">Column: {columnName}</Badge>}
          <Badge bg="success">Total Options: {options.length}</Badge>
        </div>

        {options.length === 0 ? (
          <div className="text-center text-muted py-4">
            <p>No options available</p>
          </div>
        ) : (
          <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
            <Table striped bordered hover>
              <thead>
                <tr>
                  <th style={{ width: '60px' }}>#</th>
                  <th>Value</th>
                  <th>Label</th>
                </tr>
              </thead>
              <tbody>
                {options.slice(0, 100).map((option, idx) => (
                  <tr key={idx}>
                    <td>{idx + 1}</td>
                    <td>{option.value || option}</td>
                    <td>{option.label || option}</td>
                  </tr>
                ))}
              </tbody>
            </Table>

            {options.length > 100 && (
              <p className="text-muted text-center">
                Showing first 100 of {options.length} options
              </p>
            )}
          </div>
        )}
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default MasterDataPreviewModal;
